module.exports = __webpack_public_path__ + "static/media/ic_appointment.98f4761c.svg";